<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Event Tracking Google Anayltics 4</h3>

    <label>Measurement ID</label>
    <input v-model="resource.measurement_id" type="text" />
    <span v-if="errors.measurement_id" class="alert -inline -danger">
      {{ [...errors.measurement_id].join(', ') }}
    </span>

    <label>API secret</label>
    <input v-model="resource.api_secret" type="text" />
    <span v-if="errors.api_secret" class="alert -inline -danger">
      {{ [...errors.api_secret].join(', ') }}
    </span>



    <action-button class="-mt" :text="'Update Settings'" :state="state" @pressed="submit"></action-button>
  </div>
</template>

<script>
import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";


export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: ["measurement_id","api_secret"]
    };
  }
};

</script>
